import client from "../../../../client";
import type { RequestConfig, ResponseErrorConfig } from "../../../../client";
import type {
  GetApiUserServiceQueryResponse,
  GetApiUserService401,
  GetApiUserService403,
} from "../../../types/GetApiUserService";

export function getGetApiUserServiceUrl() {
  return `/api/User/service` as const;
}

/**
 * {@link /api/User/service}
 */
export async function getApiUserService(
  config: Partial<RequestConfig> & { client?: typeof client } = {}
) {
  const { client: request = client, ...requestConfig } = config;

  const res = await request<
    GetApiUserServiceQueryResponse,
    ResponseErrorConfig<GetApiUserService401 | GetApiUserService403>,
    unknown
  >({
    method: "GET",
    url: getGetApiUserServiceUrl().toString(),
    ...requestConfig,
  });
  return res;
}
